import React from "react";
import About from "../About";

export default function AboutTeaserBlock({ id, type, ...content }) {
  return <About content={content} />;
}
